export default "__VITE_ASSET__XGygXVrL__"